import { getRequest, patchRequest } from 'services/requests';

const services = {
    getUser: (id) => getRequest(`/users/${id}`),
    updateUser: (id, body) => patchRequest(`/users/${id}`, body),
    getAssignmentDefaults: async (id) => {
        const response = await getRequest(`/users/${id}/assignment-defaults`);
        return response?.defaults || null;
    },
    updateAssignmentDefaults: (id, defaults) =>
        patchRequest(`/users/${id}/assignment-defaults`, { defaults }),
};

export default services;
